import ActivatedRupInfo from './ActivatedRupInfo';

export default ActivatedRupInfo;
